import * as React from 'react';
const IconDirectionContext = React.createContext(undefined);
const IconDirectionContextDefaultValue = {};
export const IconDirectionContextProvider = IconDirectionContext.Provider;
export const useIconContext = () => {
  var _a;
  return (_a = React.useContext(IconDirectionContext)) !== null && _a !== void 0 ? _a : IconDirectionContextDefaultValue;
};